import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { salonInfo } from '../data/mockData';

export const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroImages = [
    {
      url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/n3ean0ek_Picture%201.jpg",
      alt: "Ginos Friseure Salon Interior - View 1"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/p9btz9a1_Picture%202.jpg",
      alt: "Ginos Friseure Salon Interior - View 2"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/04wahxbp_Picture%203.jpg",
      alt: "Ginos Friseure Salon Interior - View 3"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [heroImages.length]);

  const handleBooking = () => {
    window.open(salonInfo.contact.treatwell, '_blank');
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      {/* Slideshow Background */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{
              transform: `translateX(${(index - currentSlide) * 100}%)`
            }}
          >
            <img 
              src={image.url}
              alt={image.alt}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-24 left-1/2 transform -translate-x-1/2 z-10 flex space-x-2">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`slide-indicator ${index === currentSlide ? 'active' : ''}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 lg:px-12 h-full flex items-center">
        <div className="max-w-3xl text-white">
          <div className="mb-6 inline-block">
            <span className="badge-hero">
              ⭐ {salonInfo.rating} • {salonInfo.reviewCount} Bewertungen
            </span>
          </div>
          
          <h1 className="hero-title mb-6">
            {salonInfo.name}
          </h1>
          
          <p className="hero-motto mb-8">
            {salonInfo.motto}
          </p>
          
          <p className="text-xl lg:text-2xl mb-12 text-white/90 font-light">
            {salonInfo.tagline}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              onClick={handleBooking}
              className="btn-hero-primary group"
            >
              <span>Termin buchen</span>
              <ArrowRight className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" />
            </button>
            
            <button 
              onClick={scrollToContact}
              className="btn-hero-secondary"
            >
              Kontakt aufnehmen
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="scroll-indicator">
          <div className="scroll-dot"></div>
        </div>
      </div>
    </section>
  );
};
